import classes from "./InfoCards.module.scss";
import React from "react";

type Props = {
  content: {
    icon: React.ReactNode;
    title: string;
    description?: string;
  }[];
};

function InfoCards(props: Props) {
  const { content } = props;
  return (
    <div className={classes["cards-container"]}>
      {content.map(({ icon, title, description }, index) => (
        <React.Fragment key={title}>
          <div className={classes.card} key={title}>
            <div className={classes["outer-wrapper"]}>
              <div className={classes["icon-wrapper"]}>{icon}</div>
            </div>

            <div className={classes["card-content"]}>
              <h3>{title}</h3>

              {description ? <p>{description}</p> : null}
            </div>
          </div>

          {index !== content.length - 1 && (
            <div className={classes.separator} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default InfoCards;
